function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "bl2w693h9a"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 0.240469 0 0 0 0 0.248608 0 0 0 0 0.252406 0 0 0 1.000000 0"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  filter: "url(#bl2w693h9a)",
  transform: "translate(-2307 -933) translate(1960.5 134) translate(0 24) translate(28.5 64) translate(0 699) translate(283)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#3D3F40",
  d: "M19.385 8.72c.413.034.72.395.688.808-.006.068-.548 6.779-.86 9.594-.194 1.747-1.348 2.81-3.09 2.842-1.333.023-2.62.036-3.876.036-1.355 0-2.676-.015-3.983-.042-1.672-.033-2.83-1.117-3.018-2.829-.315-2.84-.854-9.534-.86-9.601-.033-.413.275-.775.688-.808.407-.011.775.275.808.687.003.043.223 2.777.463 5.482l.048.54c.121 1.344.244 2.636.344 3.535.107.973.632 1.475 1.558 1.494 2.5.053 5.05.056 7.8.006.985-.019 1.517-.511 1.627-1.507.31-2.794.85-9.482.856-9.55.033-.412.398-.7.807-.687zM14.345 2c.918 0 1.725.62 1.962 1.506l.254 1.261c.082.414.445.716.865.722h3.282c.414 0 .75.336.75.75s-.336.75-.75.75H3.75c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h3.281l.101-.007c.376-.049.689-.335.765-.715l.243-1.216c.247-.932 1.054-1.55 1.972-1.55h4.233zm0 1.5h-4.233c-.24 0-.45.161-.512.392l-.233 1.17c-.03.148-.072.291-.128.428h5.98c-.056-.137-.099-.28-.129-.428l-.243-1.216c-.05-.185-.262-.346-.502-.346z",
  transform: "translate(35 12)"
})))))))));

var SvgIconlyLightOutlineDelete = function SvgIconlyLightOutlineDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconlyLightOutlineDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iconly-light-outline-delete.f7a1b447.svg";
export { ForwardRef as ReactComponent };